import React from 'react';
import PropTypes from 'prop-types';
import { Button as MuiButton } from '@mui/material';
import { BaseComponent } from '../../prop-types/component';

export const Button = ({ children, variant, dark, sx, ...props }) => {
  const getColor = () => {
    if (dark) return '#FFFFFF';
    if (variant === 'outlined') return '#0F172A';
    return '#FFFFFF';
  };

  return (
    <MuiButton
      variant={variant}
      {...props}
      sx={{
        ...sx,
        borderColor: dark ? 'rgba(255,255,255,0.4)' : undefined,
        color: getColor(),
      }}
    >
      {children}
    </MuiButton>
  );
};

Button.propTypes = {
  ...BaseComponent,
  variant: PropTypes.string,
};
